const popups = [

   {
        latitude: 51.05195116969476,
        longitude: 3.725377684659833,
        name:"WONDR care Flagship Store Gent",
        address: "Koestraat 2, 9000 Gent"
    },
    {
        latitude: 51.218265485383256,
        longitude: 4.413078781338562,
        name:"WONDR care Flagship Store Antwerpen",
        address: "Leysstraat 6, 2000 Antwerpen"
    },
    {
        latitude: 51.152660089903094,
        longitude: 4.154132898074235,
        name:"POP-UP Waasland Shopping",
        address: "Kapelstraat 100, 9100 Sint-Niklaas"
    },
    {
        latitude: 51.22159274390813,
        longitude: 4.499809767395044,
        name:"POP-UP Wijnegem Shopping",
        address: "Turnhoutsebaan 5, 2110 Wijnegem"
    },
    {
        latitude: 50.83840677461361,
        longitude: 4.2883437980647106,
        name:"POP-UP Westland Shopping",
        address: "Bd Sylvain Dupuis 433, 1070 Brussels"
    },
    {
        latitude: 50.82662833427589,
        longitude: 3.2704690423653227,
        name:"POP-UP K in Kortrijk",
        address: "Steenpoort 2, 8500 Kortrijk"
    },
    {
        latitude: 50.40820398561574,
        longitude: 4.441524226886895,
        name:"POP-UP Rive Gauche Charleroi",
        address: "Place Verte n°20 - Boite 2, 6000 Charleroi"
    },
    {
        latitude: 52.091179066325125,
        longitude: 5.119658069267922,
        name:"POP-UP Utrecht",
        address: "Choorstraat 9, Utrecht"
    },
    {
        latitude: 50.93976518135754,
        longitude: 4.0365824134084525,
        name:"POP-UP Aalst",
        address: "Pieter Van Aelst Passage - De Ridderstraat 4, 9300 Aalst"
    },
    {
        latitude: 51.23181280695276,
        longitude: 2.916601226911828,
        name:"POP-UP Oostende",
        address: "Adolf Buylstraat 14, 8400 Oostende"
    },
    {
        latitude: 50.88089327866418,
        longitude: 4.706520367384707,
        name:"POP-UP Leuven",
        address: "Diestsestraat 107, 3000 Leuven"
    },
    {
        latitude: 51.0237707653793,
        longitude: 4.482305098070369,
        name:"POP-UP Mechelen",
        address: "Bruul 113, 2800 Mechelen"
    },
    {
        latitude: 50.94605233492218,
        longitude: 3.1249400600499646,
        name:"POP-UP Roeselare",
        address: "Ooststraat 17, 8800 Roeselare"
    }
]